import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { TableTree } from "components/TableTree/TableTree";
import { Toast } from "components/ToastShow/ToastAlert";
import { Toolbar } from "components/Toolbar/Toolbar";
import { getEnv } from "config/runtimeEnv";
import { FilterReportForm } from "layouts/DashboardLayout/components/Sidebar/component/FilterReportForm";
import { useEffect, useState } from "react";
import { MessageType } from "types/enum";
import { REPORT_URL } from "utils/constants";
import { ENDPOINTSREPORT } from "utils/endpoints";
import { trans } from "utils/helpers";
import { createMenu, deleteReport, exportReport, getReports, syncReports } from './api';
import { ImportReportForm } from "./components/ImportReportForm";
import { WithFeedForm } from "./components/WithFeed";

export const Reports   = () => {
  const [data, setData] = useState<any>()
  const [forceUpdate, setForceUpdate] = useState(false)
  const [selectedObj, setSelectedObj] = useState<any>()
  const [loading, setLoading] = useState(false);
  const [messageType, setMessageType] = useState<any>("info");
  const [search, setsearch] = useState(null);
  const [idCallback, setIdCallback] = useState<any>("2")
  const [mode, setMode] = useState<any>(null)
  const [showForm, setShowForm] = useState<any>(null)
  const [filterReportId, setFilterReportId] = useState<any>(null);
  const [designType,setDesignType]=useState('')
  const [showImportReportForm, setShowImportReportForm] = useState(false)

  const clickToolbarCallback = (clickedButtonName: string) => {
    switch (clickedButtonName.toLowerCase()) {
      case "print":alert("print ");break;
      case "refresh":setForceUpdate(!forceUpdate);break;
      case "create":setMode("create"); setShowForm(true);break;
      // case "design": if (selectedObj?.Id) handleDesignRow(); break;
      case "export": if (selectedObj && selectedObj.ParentId == null)exportAsync(selectedObj); break;
      case "import": setShowImportReportForm(true); break;
      case "edit": if (selectedObj?.Id) handleEditRow(); break;
      case "sync":handleSyncAsync();break
      case "createmenu":{handleCreateMenu()}break;
      case "remove": if (selectedObj?.Id) Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete , handleDeleteRow); break;
    }
  };


const handleSyncAsync=async()=>{
try{
  await syncReports()
}
catch(error){

}


}

  const handleCreateMenu=async()=>{
    setLoading(false)
    try{
    const res=  await createMenu(false)
    }
    catch(error){}
    setLoading(true)
  }

    async function exportAsync(obj) {
      try {
      const respons = await exportReport(obj.Id)
     const contentDisposition = respons.headers['content-disposition'];
     let fileName = 'downloaded-file'; // Default filename
 
     if (contentDisposition) {
       const fileNameMatch:any = contentDisposition.match(/filename="(.+)"/);
       if (fileNameMatch.length > 1) {
         fileName = fileNameMatch[1];
       }
     }
     var pom = document.createElement('a');
     pom.setAttribute('href', window.URL.createObjectURL(respons.data));
     pom.setAttribute('download',obj.Name?obj.Name : fileName);
     pom.click();
      } catch (error) {
        setMessageType("error")
      }
  
    }
  const reportDesignCallBack=(type)=>{
    if(selectedObj?.Id && (!selectedObj.IsDashboard)) handleDesignRow()
    setDesignType(type);
  if(selectedObj.IsDashboard){
    if(mode=="view"){
    window.open(`${getEnv("REACT_APP_REPORTING_SERVICE_URL")+ "/DashboardViewer/View/"}${selectedObj?.Id }?userDataId=${sessionStorage.getItem("accept-data")} `,"_blank" );  
  }else{
    window.open(`${getEnv("REACT_APP_REPORTING_SERVICE_URL")+ "/DashboardDesigner/Index/"}${selectedObj?.Id }?userDataId=${sessionStorage.getItem("accept-data")}&newVersion=${type=='FileWithNewVersion'?true:false}`,"_blank" );  
  }
  }
  }

  const handleDesignRow = () => {
    setFilterReportId(selectedObj )
    //if(!selectedObj.IsPrintTemplate){
//
    //}else{
    ////  GetReportWithJsonData(selectedObj.Id,null,0)
    //}
}
  const handleEditRow = () => {
    setMode("edit")
    setShowForm(true)

}

  const handleDeleteRow =async () => {
    try {
        await deleteReport(selectedObj.Id)
        setForceUpdate(!forceUpdate)
    } catch (error) {
        
    }

}

  async function getMenuAsync() {
    setLoading(false)
    try {
      const respons = await getReports(null)
      setData(respons.Data)
    } catch (error) {
      setMessageType("error")
    }
    setLoading(true)

  }


  useEffect(() => {
    setData(null)
    getMenuAsync()
  }, [forceUpdate]);
  useEffect(() => {
    if(idCallback){
      setIdCallback(null)
    }
  }, [idCallback]);

  return (
    <>

{
        filterReportId &&
          <ModalForm mode={"edit"} title={trans("Report")+" : " +filterReportId?.Name}onHide={() => setFilterReportId(null)} show={filterReportId} modalHeight={60}>
              <FilterReportForm designType={designType} Id={filterReportId?.Id}  onHide={() => setFilterReportId(null)} mode={"edit"} />
          </ModalForm>
      }
      {
        showForm &&
          <ModalForm mode={mode} title="Report" onHide={() => setShowForm(false)} show={showForm} modalHeight={60}>
              <WithFeedForm 
                onHide={() => setShowForm(false)}
                saveCallback={(e)=>{if(e.IsDashboard){     window.open(`${getEnv("REACT_APP_REPORTING_SERVICE_URL")+ "/DashboardDesigner/Index/"}${selectedObj?.Id }?userDataId=${sessionStorage.getItem("accept-data")}&newVersion=${false}`,"_blank" );  
              }else{ setFilterReportId(e )  ;setIdCallback(selectedObj.Id)} }}
                selectedObj={selectedObj} 
                mode={mode} 
              />
          </ModalForm>
      }

      {
        showImportReportForm &&
        <ModalForm modalHeight={80} modalProfileKey={"Users"} title={"import"} onHide={() => setShowImportReportForm(false)} show={showImportReportForm}>
          <ImportReportForm reload={()=>{ setShowImportReportForm(false) ;setForceUpdate(!forceUpdate);}}  showForm={() => { setShowImportReportForm(false) }} />
        </ModalForm>
      }
      <Toolbar 
      
    sync={true} createMenu={true}  Export={selectedObj?.ReportTree?.length!=0} Importprocesses={true} reportDesignCallBack={reportDesignCallBack} excel={false} reportDesign={selectedObj&&selectedObj?.ReportTree==null}   create={true}  view={false} remove={(selectedObj&&selectedObj?.ReportTree==null)} edit={(selectedObj&&(selectedObj?.ReportTree==null && !selectedObj.IsPrintTemplate))} emptyList={data?.length == 0} id={selectedObj} Tree={false}  search={true}  handleClickToolbar={clickToolbarCallback} 
      
       

         

/>      <div style={{overflowY: "auto", 
          height: "72vh",
           scrollbarWidth: "thin"}} className="col-lg-12 mt-3 ">
        <div className="list-card card ">
            
          {
            loading ? (
              data ?
              <>    
                <TableTree
                  search={search}
                  maxLevel={1}
                  params={"Scope"}
                  IdParams={"Scope"}
                  Childrenparams={"ReportTree"}
                  Titleparams={"Name"}
                  selectedRowObjectCallback={setSelectedObj}
                  selectedRowObject={idCallback}
                  Data={data}
                  theadData={Object.keys(data[0])}
                  parentName={"Reports "}
                  startIndex={4}
                  getChildrenUrl={ENDPOINTSREPORT.Report.tree}
                  baseUrl={REPORT_URL}

                  />
                  </>
                 : <Message message={"NoDataForPreview"} type={messageType} />)

              : <Loading />
          }
        </div>
      </div>
    </>
  )
}